<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="app">
        <div style="width: 100%;">
            <top-title></top-title>
        </div>
        <b-navbar toggleable="lg" type="dark" variant="info">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="container" :justified="true" :small="false">
                    <b-nav-item :active="navName == 'home'" to="/index" class="nav-item-style nav-index-right-line">首
                        页</b-nav-item>
                    <b-nav-item :active="navName == 'timeline'" to="/timeline" class="nav-item-style">项目时间尺</b-nav-item>
                    <b-nav-item :active="navName == 'news'" to="/news?type=1" class="nav-item-style">公告新闻</b-nav-item>
                    <b-nav-item :active="navName == 'options'" to="/options" class="nav-item-style">搭载需求申请</b-nav-item>
                    <!--          <b-nav-item :active="navName == 'diary'" to="/diary_list" class="nav-item-style">航次日记</b-nav-item>-->
                    <!--          <b-nav-item :active="navName == 'timeline'" to="/timeline" class="nav-item-style">在研项目进程</b-nav-item>-->
                    <b-nav-item :active="navName == 'voyage'" to="/voyage" class="nav-item-style">历年航次信息</b-nav-item>
                    <!-- <b-nav-item
            :active="navName == 'scientificOrientation'"
            to="/scientificOrientation"
            class="nav-item-style"
          >科学导向</b-nav-item>-->
                    <b-nav-item :active="navName == 'about'" to="/about" class="nav-item-style">关于我们</b-nav-item>
                    <!--<b-nav-item :active="navName == 'about2'" href="/about2" class="nav-item-style" disabled></b-nav-item>-->
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <div style="min-height:400px">
            <keep-alive>
                <!-- <transition name="slide"> -->
                <router-view />
                <!-- </transition> -->
            </keep-alive>
        </div>

        <global-footer></global-footer>
    </div>
</template>

<script>
import topTitle from './components/GlobalTop.vue';
import GlobalFooter from './components/GlobalFooter.vue';

export default {
    name: 'app',
    components: {
        GlobalFooter,
        topTitle
    },
    data() {
        return {
            navName: ''
        };
    },
    watch: {
        $route(to, from) {
            this.navName = to.path.substring(1);
        }
    },
    mouted() { },
    activated() { }
};
</script>

<style scoped>
/*覆盖bootstrap的内置的样式 开始*/
.nav-link {
    color: #fff !important;
    padding: 0px 10px !important;
}
</style>

<style>
input {}

html {
    overflow-y: scroll;
}

/*表单group的title颜色*/
.d-block {
    /* font-weight: bold !important; */
    /*color: #115CA5*/
    /* color: #0582bb */
}

.login-header {
    font-size: 20px;
    font-weight: bold;
    color: #115ca5;
}

.form-background {
    /*background-color: #eff9ec*/
    /*background-color: #ebf5ec;*/
    /*background-color: #f0f2f5;*/
    /* background-color: #f1f1f1; */
}

.breadcrumb {
    background-color: #fff;
    margin-bottom: 0px;
    padding-left: 5px;
}

.bg-info {
    background-color: #115ca5 !important;
}

i.icon_index {
    width: 30px;
    height: 30px;

    background-color: green;
}

.navbar {
    padding: 0px;
    /*导航栏ul去掉padding*/
}

#nav-collapse>ul>li>a:hover {
    /*活动时候的颜色背景*/
    background-color: #2283e0;
}

a.nav-link.active {
    /*选中时候的颜色*/
    background-color: #2283e0;
}

/*覆盖bootstrap的内置的样式 结束*/

/*导航栏高度字体等设置*/
.nav-item-style {
    /*background-color: green;*/
    font-size: 16px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    /*border-right: solid 1px #b3cced;*/
    font-weight: bold;
    /*white-space: pre;*/
    letter-spacing: 3px;
}

.nav-index-right-line {
    /*border-left: solid 1px #b3cced;*/
}

#app {
    /*font-family: "Avenir", Helvetica, Arial, sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    background-color: white !important;
    letter-spacing: 1px;
}

/* 全局样式 */
/* 元素属性样式 */
.inline {
    display: inline;
}

/* 间距设置 */
.m10 {
    margin: 10px;
}

.m3 {
    margin: 3px;
}

.ml {
    margin: 0 10px;
}

.mt10 {
    margin-top: 10px;
}

.mt20 {
    margin-top: 20px;
}

.mat {
    margin: auto;
}

.mr10 {
    margin-right: 10px;
}

.matv {
    margin: auto 0;
}

.math {
    margin: 0 auto;
}

.p5 {
    padding: 5px;
}

.p10 {
    padding: 10px;
}

.pt20 {
    padding-top: 20px;
}

/* 颜色样式 */
.color-sb {
    background-color: #60afdd;
}

.color-b {
    background-color: #5389d7;
}

.color-p {
    background-color: #777dcd;
}

/* 边界线样式 */

.borderB {
    border-bottom: none;
}

/* 字体样式 */
/* 行高 */
.lh32 {
    line-height: 32px;
}

a {
    color: #303133;
}
</style>
